/**
 * Helper functions targeted FROM the WebWorker.
 * Reduces the boilerplate code and simplifies the usage of the WebWorker.
 *
 * This file works in cooperation with toWorker.ts
 */
import type { PartialRecord } from '@/core/helperTypes'

// The map of all events/actions your WebWorker can react on.
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const actionsMap: PartialRecord<string, Function> = {}

/**
 * Register an action that WebWorker gonna react to.
 *
 * Provide type as a key and callback function with expected payload.
 * The callback function can return a value or promise
 * to return the result of the execution.
 */
export const action = <T, R = void>(type: string, callback: (payload: T) => R): void => {
  actionsMap[type] = callback
}

self.onmessage = async (ev: MessageEvent): Promise<void> => {
  if (!ev.data) {
    return
  }

  const port = ev.ports[0]

  const { type, payload } = ev.data

  if (!type) {
    return
  }

  const res = await actionsMap[type]?.(payload)

  if (port) {
    port.postMessage({
      type,
      payload: res,
    })
    return
  }

  self.postMessage({
    type,
    payload: res,
  })
}
